<template>
  <L1 class="editEvent">
    <template slot="slot_title">
      <RT :style="{marginLeft: 'auto'}" :options="['活動內容', '預約須知', '時段設定', '費用設定']" :defaultValue="page" @input="page=$event"/>
    </template>
    <setcontent v-if="page==='活動內容'"/>
    <babybookset v-else-if="page==='預約須知'"/>
    <babybooktime v-else-if="page==='時段設定'"/>
    <babypayset v-else-if="page==='費用設定'"/>
  </L1>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import babybooktime from './babybooktimeset.vue'
import babybookset from './babybookset.vue'
import babypayset from './babypayset.vue'
import setcontent from './editBabyContent.vue'
export default {
  components: {
    L1,
    setcontent,
    babybookset,
    babybooktime,
    babypayset
  },
  data () {
    return {
      name: null,
      item: null,
      page: '活動內容'
    }
  },
  async mounted () {
  }
}
</script>
<style lang="scss" scoped>

.header {
  padding-right: 36px;
  height: 89px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: inline-flex;
      width: 55px;
      height: 55px;
      mask-image: url(/setting.svg);
      background-color: var(--color-pri);
      mask-position: center;
      mask-repeat: no-repeat;
      margin-inline: 10px;
    }
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
.editEvent {
  position: relative;
  height: 100vh;
  div {
    box-sizing: border-box;
  }
  input[type=text] {
    padding-inline: .5em;
    box-sizing: border-box;
  }
}
.radios {
  display: flex;
}
input[type=radio] {
  appearance: none;
  background-color: #C4C4C4;
  min-width: 125px;
  width: fit-content;
  height: 40px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  letter-spacing: 0.1em;
  &:checked {
    background-color: var(--color-checked);
  }
  &::after {
    content: attr(value);
  }
}
</style>
